/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { beneficiaryTransactionsDetailsById } from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import useCategories from "../../../../utils/useCategories";

const BeneficiaryTransactionSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categoryMapper = useCategories();

  const {
    beneficiaryTransactionsDetailsData,
    beneficiaryTransactionsDetailsLoading,
    beneficiaryTransactionsDetailsError,
  } = useSelector((state) => state.beneficiaryTransactions);

  const transaction = beneficiaryTransactionsDetailsData?.transaction?.[0];

  const viewDetailsHandler = () => {
    navigate(
      `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };

  const beneAccount = () => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${transaction?.beneficiary_account_id}`,
      {
        replace: true,
      },
    );
  };

  const sourceAccount = () => {
    navigate(
      `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${transaction?.owner_account_id}`,
      {
        replace: true,
      },
    );
  };

  const status = transaction?.lifecycle_status;

  const createAccountHandler = () => {
    navigate(
      "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
      {
        replace: true,
      },
    );

    sessionStorage.removeItem("recreate_ben");
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_transaction_dashboard", {
      replace: true,
    });
  };

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON_WHITE,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);

  useEffect(() => {
    if (
      beneficiaryTransactionsDetailsError ===
      "Request failed with status code 404"
    ) {
      navigate(
        `/beneficiary_transaction_dashboard/create_beneficiary_transaction/failed`,
      );
    }
  }, [beneficiaryTransactionsDetailsError]);

  useEffect(() => {
    if (id) {
      dispatch(beneficiaryTransactionsDetailsById({ id }));
    }
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch, id]);

  return (
    <>
      <StatusContainer
        isLoading={beneficiaryTransactionsDetailsLoading}
        status="success"
        hoverOption="white"
        title={
          status === "approved"
            ? "Beneficiary transaction created and approved successfully."
            : status === "queued"
              ? "Beneficiary transaction has been approved"
              : status === "settled"
                ? "Beneficiary transaction settled successfully."
                : status === "pending"
                  ? "Beneficiary transaction created successfully and approval is pending."
                  : ""
        }
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Transaction details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          transaction?.amount ??
                          GlobalConfiguration?.lengthCheckZero
                        }
                      />
                    </>
                  ),
                  leftSubTitle: "Amount",
                  hasRight: true,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: transaction?.beneficiary_account_name,
                  leftSubTitle: "Account name",
                  hasRight: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: transaction?.category_id?.category_name,
                  leftSubTitle: "Category",
                  iconSize: "small",
                  icon: categoryMapper(transaction?.category_id?.category_id)
                    ?.url,
                  iconColor: categoryMapper(
                    transaction?.category_id?.category_id,
                  )?.colour,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              onClick={sourceAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    transaction?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: globalText?.SOURCE_ACCOUNT_NUMBER,
                  ifsc: transaction?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={beneAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    transaction?.beneficiary_account_bank_acc_no,
                  ),
                  leftSubTitle: globalText?.DESTINATION_ACCOUNT_NUMBER,
                  ifsc: transaction?.beneficiary_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            {transaction?.confidential_transaction === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: globalText?.YES,
                    leftSubTitle: globalText?.CONFIDENTIAL_TRANSACTION,
                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array.isArray(transaction?.labels) &&
                    transaction?.labels.length > 0
                      ? transaction?.labels.map((item, index, arr) => (
                          <span key={item}>
                            {item}
                            {index <
                              arr.length -
                                GlobalConfiguration?.lengthCheckOne && ", "}
                          </span>
                        ))
                      : globalText?.NO_LABELS_ASSIGNED,
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            {/* 
            {(transaction?.lifecycle_status === "pending" ||
              transaction?.lifecycle_status === "approved") && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      transaction?.lifecycle_status === "pending" &&
                      !beneficiaryTransactionsDetailsLoading
                        ? "Pending"
                        : transaction?.lifecycle_status === "approved" &&
                            !beneficiaryTransactionsDetailsLoading
                          ? "Created distribution"
                          : "",
                    leftSubTitle: globalText?.TRANSACTION_STATUS,
                    icon:
                      transaction?.lifecycle_status === "pending"
                        ? ICONS?.PENDING_BLUE
                        : transaction?.lifecycle_status === "approved"
                          ? ICONS?.AWAITING_VERIFICATION
                          : ICONS?.LOADER_GIF,
                    iconColor:
                      transaction?.lifecycle_status === "approved"
                        ? "var(--awaiting)"
                        : "",
                  },
                ]}
              />
            )} */}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: id,
                  leftSubTitle: "Transaction ID",
                  copyText: id,
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default BeneficiaryTransactionSuccess;
